import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartShopifyService {

  private getApiUrl(): string {
    return (window as any).Shopify?.routes?.root || 'https://slicksell-test.myshopify.com';
  }

  constructor(private http: HttpClient) { }

  addToCart(item: { id: number; quantity: number }): Observable<any> {
    const apiUrl = this.getApiUrl(); // 🔥 Obtém dinamicamente a URL base da Shopify
    return this.http.post(`${apiUrl}cart/add.js`, {
      items: [item]
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }


  /** 🔥 Novo método para obter detalhes do carrinho na Shopify */
  getCartDetails(): Observable<any> {
    const apiUrl = this.getApiUrl();
    const timestamp = new Date().getTime(); // 🔥 Garante URL única para evitar cache

    console.log('dentro de getCartDetails')
    return this.http.get(`${apiUrl}cart.js?nocache=${timestamp}`, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
  }


  /** 🔥 Atualiza a quantidade de um item no carrinho */
  updateCartItemQuantity(key: string, quantity: number): Observable<any> {
    const apiUrl = this.getApiUrl();
    return this.http.post(`${apiUrl}cart/change.js`, {
      id: key, // 🔥 Enviar `key`, não `variant_id`
      quantity
    }, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  /** 🔥 Remove um item do carrinho (define a quantidade como 0) */
  removeFromCart(key: string): Observable<any> {
    const apiUrl = this.getApiUrl();
    return this.http.post(`${apiUrl}cart/change.js`, {
      id: key,
      quantity: 0
    }, {
      headers: { 'Content-Type': 'application/json' }
    });
  }


  getCheckoutUrl(): string {
    const apiUrl = this.getApiUrl();
    return `${apiUrl}checkout`;
  }
}
